import { useEffect, useMemo, useState } from 'react';

import { parseCountdownTargetMs } from './countdownUtils';

export type CountdownRemaining = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  completed: boolean;
};

function calcRemaining(targetMs: number, now: number): CountdownRemaining {
  const diff = Math.max(0, targetMs - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return {
    days,
    hours,
    minutes,
    seconds,
    completed: diff <= 0,
  };
}

/**
 * 每秒刷新剩余时间；不依赖 react-countdown，避免演示态 content-visibility 等导致计时停住。
 */
export function useCountdownRemaining(
  date: Date | string | number | null | undefined,
): CountdownRemaining | null {
  const targetMs = parseCountdownTargetMs(date);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (targetMs == null) return;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [targetMs]);

  return useMemo(() => {
    if (targetMs == null) return null;
    return calcRemaining(targetMs, now);
  }, [targetMs, now]);
}
